import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "../views/user/SignIn";
import Cookies from "js-cookie";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Pacientes",
    icon: "mdi-account-multiple",
    main: true,
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/patients/PatientsList.vue"
      ),
  },
  {
    path: "/:patientId/tratamientos",
    name: "Tratamientos",
    main: false,
    props: true,
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/treatments/TreatmentsList.vue"
      ),
  },
  {
    path: "/login",
    name: "Login",
    icon: "mdi-login",
    component: SignIn,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const user = Cookies.get("user");
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!user || user == "null" || user == undefined) {
      return next({
        path: "/login",
      });
    }
    return next();
  } else {
    if (user && user != "null" && user != undefined) {
      return next({
        path: "/",
      });
    }
    return next();
  }
});

export default router;
